var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "273.000000pt",
    height: "265.000000pt",
    viewBox: "0 0 273.000000 265.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,265.000000) scale(0.100000,-0.100000)",
    fill: "#919191",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1325 l0 -1325 1365 0 1365 0 0 1325 0 1325 -1365 0 -1365 0 0 -1325z m656 1005 l64 0 0 -130 0 -130 130 0 130 0 0 -90 0 -90 -130 0 -130 0 0 -130 0 -130 -90 0 -90 0 0 130 0 130 -130 0 -130 0 0 90 0 90 130 0 130 0 0 129 c0 131 4 146 38 135 8 -2 43 -4 78 -4z m1104 -343 l74 -82 172 -5 172 -5 39 -31 c77 -61 74 -33 73 -669 0 -618 1 -607 -59 -657 -56 -48 -85 -50 -846 -46 l-710 3 -40 23 c-22 13 -52 39 -65 59 l-25 37 0 465 0 466 128 3 127 3 0 129 0 130 130 0 130 0 0 123 c0 68 3 127 7 130 3 4 144 7 312 7 l306 -1 75 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318 1614 c-221 -53 -367 -269 -329 -486 61 -347 465 -485 725 -247 112 102 158 258 122 412 -20 86 -43 131 -101 195 -57 63 -131 107 -216 127 -77 18 -125 18 -201 -1z m195 -154 c190 -71 245 -315 105 -460 -38 -39 -116 -77 -174 -86 -74 -11 -180 31 -234 92 -122 140 -85 354 75 436 83 43 147 48 228 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/AddImageIcon.644926d6b1a034270d59d5a54bc6c4dd.svg";
export { ForwardRef as ReactComponent };